export interface GlofoxNavLink {
  href: string;
  icon: string;
  label: string;
  testId?: string;
}

export interface GlofoxFlowSection {
  title: string;
  items: GlofoxNavLink[];
}

export const GLOFOX_OVERVIEW_LINKS: GlofoxNavLink[] = [
  { href: "/glofox", icon: "ti-home", label: "Get started", testId: "gf-sidebar-home" },
  {
    href: "/glofox/authentication",
    icon: "ti-lock",
    label: "Authentication",
    testId: "gf-sidebar-authentication",
  },
  {
    href: "/glofox/common-concepts",
    icon: "ti-topology-star",
    label: "Common concepts",
    testId: "gf-sidebar-common-concepts",
  },
  {
    href: "/glofox/webhooks",
    icon: "ti-webhook",
    label: "Webhooks",
    testId: "gf-sidebar-webhooks",
  },
];

/** Flow guides grouped by integration journey. */
export const GLOFOX_FLOW_SECTIONS: GlofoxFlowSection[] = [
  {
    title: "Onboarding",
    items: [
      {
        href: "/glofox/flows/lead-sale",
        icon: "ti-user-plus",
        label: "Lead capture and sale flow",
        testId: "gf-sidebar-flow-lead-sale",
      },
      {
        href: "/glofox/flows/login",
        icon: "ti-login",
        label: "Member login flow",
        testId: "gf-sidebar-flow-login",
      },
      {
        href: "/glofox/flows/agreements",
        icon: "ti-file-text",
        label: "Waiver and T&C flows",
        testId: "gf-sidebar-flow-agreements",
      },
      {
        href: "/glofox/flows/avatar",
        icon: "ti-user-circle",
        label: "Avatar",
        testId: "gf-sidebar-flow-avatar",
      },
      {
        href: "/glofox/flows/push-notifications",
        icon: "ti-bell",
        label: "Push notifications",
        testId: "gf-sidebar-flow-push-notifications",
      },
    ],
  },
  {
    title: "Payments",
    items: [
      {
        href: "/glofox/flows/payment-collector",
        icon: "ti-credit-card",
        label: "Payment collector",
        testId: "gf-sidebar-flow-payment-collector",
      },
      {
        href: "/glofox/flows/overdue-invoices",
        icon: "ti-receipt",
        label: "Overdue invoices",
        testId: "gf-sidebar-flow-overdue-invoices",
      },
      {
        href: "/glofox/flows/purchase-product",
        icon: "ti-shopping-cart",
        label: "Purchase product",
        testId: "gf-sidebar-flow-purchase-product",
      },
    ],
  },
  {
    title: "Booking",
    items: [
      {
        href: "/glofox/flows/book",
        icon: "ti-calendar-event",
        label: "Bookings workflow",
        testId: "gf-sidebar-flow-book",
      },
    ],
  },
];
